import React, {Component} from "react";
import {Card, CardBody, Col, Collapse, Row} from "reactstrap";
import moment from "moment-es6"
import {isResume} from "../../../services/player-game-session-service/player-game-session-service";

import Hr from '../../components/hr/hr'
import Button from "../button/button";
import PlayerActivitiesSummaryCard from "../player-activities-summary-card/player-activities-summary-card";
import Input from "../input/input";
import FormSection from "../form-section/form-section";

class PlayerGameSessionCard extends Component {
    constructor(props) {
        super(props);

        const playerGameSession = props.playerGameSession || {};

        this.state = {
            isOpenActivities: false,
            isOpenGameSessionNotes: false,
            notesText: playerGameSession.notes || "",
            playerGameSession
        }
    }

    componentDidUpdate() {
        const {playerGameSession} = this.state;
        const _playerGameSession = this.props.playerGameSession;

        if (_playerGameSession && _playerGameSession.id &&
            _playerGameSession.id !== playerGameSession.id) {

            this.setState({
                playerGameSession: _playerGameSession,
                notesText: _playerGameSession.notes
            })
        }
    }

    render() {
        const { isActive, isEdit, isActivities,
            onClickViewSession, onClickPlayActiveSession, onClickResumeSession, onClickSaveNotes
        } = this.props;

        const {playerGameSession, notesText, isOpenActivities, isOpenGameSessionNotes} = this.state;

        const isSameNotes = isEdit && playerGameSession &&
            notesText === playerGameSession.notes;
        const _activities = playerGameSession._activities;
        const _activityCards = playerGameSession._activityCards;

        const _created = new Date(playerGameSession._created);
        const createdDisplay = moment(_created).format('MM/DD/YYYY h:mm a');

        let _results = _activities && _activities
            .filter(activity => !!activity._result)
            .map(activity => activity._result);

        const _isResume = onClickResumeSession && _activities && isResume(playerGameSession, _activities);
        return (
            <Card className={`ml-1 mr-2 mt-1 px-0 border ${isActive ? "shadow-lg border-primary" : "shadow-sm"}`}>
                <CardBody className="m-0 px-0 py-2">
                    <Row className="mp-0">
                        <h5 className="mb-0 pl-2 pb-0">{playerGameSession.game_session_name || playerGameSession.name || "<No Active Session>"}<Hr/>
                        </h5>
                        <p className="ml-auto mr-3 my-0 p-0">
                            {onClickViewSession &&
                            <Button
                                size="sm"
                                color="success"
                                outline
                                className="mr-1"
                                onClick={onClickViewSession}
                                text="View Session"/>
                            }
                            {_isResume && onClickResumeSession &&
                            <Button
                                size="sm"
                                color="warning"
                                outline
                                className="mr-1"
                                onClick={onClickResumeSession}
                                text="Resume Session"/>
                            }
                            {onClickPlayActiveSession &&
                            <Button
                                size="sm"
                                color="primary"
                                className="mr-1"
                                onClick={onClickPlayActiveSession}
                                text="Replay Session"/>
                            }
                        </p>
                    </Row>
                    <div className="mp-0 secondary-color small">
                        <Row className="mp-0">
                            <Col className="mp-0">
                                <p className="mx-1 my-0 p-0">
                                            <span className="pr-2 font-weight-bold">
                                                Session Date:
                                            </span>
                                    {createdDisplay}
                                    {playerGameSession._user &&
                                    <span> / {`${playerGameSession._user.first_name} ${playerGameSession._user.last_name}`}
                                        </span>
                                    }
                                </p>
                            </Col>
                        </Row>
                    </div>

                    {isEdit &&
                    <Row className="mp-0">
                        <Col className="m-1 p-0">
                            <Row className="mp-0">
                                <div className="mp-0 container-fluid">
                                    <FormSection
                                        sectionLabel="Session Notes"
                                        component={<Row className="mp-0 container-fluid">
                                            <Col md={12} className="m-0 pl-0 pr-3 py-0">
                                                <Input
                                                    name="notes"
                                                    value={notesText}
                                                    onChange={notesText => {
                                                        this.setState({notesText});
                                                    }}
                                                    placeholder="Notes"
                                                    type="textarea"
                                                />
                                            </Col>
                                            <div className="ml-auto mr-4 mt-1 mb-2 text-right">
                                                <Button
                                                    className="ml-1"
                                                    text={"Save"}
                                                    onClick={() => {
                                                        onClickSaveNotes(this.state.notesText)
                                                    }}
                                                    disabled={isSameNotes}
                                                    color="primary"
                                                />
                                            </div>
                                        </Row>
                                        }/>
                                </div>
                            </Row>
                        </Col>
                    </Row>
                    }

                    <Row className="mx-0 mb-1 p-0">
                        {_results &&
                        <Col md={6} className="m-0 pl-1 pr-0 py-0">
                            <PlayerActivitiesSummaryCard results={_results} small/>
                        </Col>
                        }

                        {!isEdit &&
                        <Col className="ml-4 mr-1 my-0 pl-2 pr-1 py-0 border-left border-info">
                            <Row className="mp-0 border-left background-light-grey-color">
                                <div className="mp-0 container-fluid">
                                    <Row className="mp-0">
                                        <p className="mp-0 font-italic">Notes:</p>
                                    </Row>
                                    <p className="m-0 pl-2 pr-0 py-0 small secondary-color">{notesText}</p>
                                </div>
                            </Row>
                        </Col>
                        }
                    </Row>

                    <Row className="mx-0 mb-1 p-0 small">
                        <p className="mp-0 container-fluid"><Hr/></p>
                        <Row className="mp-0 container-fluid">
                            <p className="mp-0 font-italic font-weight-bold secondary-color pointer"
                               onClick={() => {
                                   this.setState({isOpenGameSessionNotes: !isOpenGameSessionNotes})
                               }}
                            >
                                <i className={`mx-2 fa ${isOpenGameSessionNotes ? "fa-caret-down" : "fa-caret-right"}`}/>
                                Session Notes
                            </p>

                            {!!_activityCards &&
                            <p className="ml-3 mr-0 my-0 p-0 font-italic font-weight-bold secondary-color pointer"
                               onClick={() => {
                                   this.setState({isOpenActivities: !isOpenActivities})
                               }}
                            >
                                <i className={`mx-2 fa ${isOpenActivities ? "fa-caret-down" : "fa-caret-right"}`}/>
                                {isActivities ? "Activities" : "Activities"} ({_activityCards.length})
                            </p>
                            }
                        </Row>

                        {playerGameSession._gameSession &&
                        <Row className="mp-0 container-fluid">
                            <Collapse isOpen={isOpenGameSessionNotes} className="ml-2">
                                <Row className="mp-0">
                                    <p className="mp-0 font-italic activity_card_label">Session Bank Notes:</p>
                                </Row>
                                <Row className="mp-0 border-left background-light-grey-color">
                                    <p className="m-0 pl-2 pr-0 py-0 small secondary-color activity_card_value">{playerGameSession._gameSession.notes}</p>
                                </Row>
                            </Collapse>
                        </Row>
                        }

                        <Row className="mp-0 container-fluid">
                            <Collapse isOpen={isOpenActivities}>
                                <Row className="mp-0">
                                    {!!_activityCards &&
                                    _activityCards.map(activity => <div className="m-0 p-1"
                                                                        style={{width: 200}}>{activity}</div>)
                                    }
                                </Row>
                            </Collapse>
                        </Row>
                    </Row>
                </CardBody>
            </Card>
        )
    }
}

export default PlayerGameSessionCard;



// WEBPACK FOOTER //
// ./src/components/components/player-game-session-card/player-game-session-card.js